import React from 'react'
import { motion } from 'framer-motion'
import { Construction, Mail, Phone } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const DevelopmentNoticePage: React.FC = () => {
  const { } = useTranslation(['contact'])

  return (
    <div className="min-h-screen pt-16">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-br from-kylix-primary via-purple-800 to-pink-800 text-white">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              className="w-32 h-32 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-8"
            >
              <Construction className="w-16 h-16 text-white" />
            </motion.div>
            
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-5xl font-bold mb-6"
            >
              Conteúdo em Desenvolvimento
            </motion.h1>
            
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-xl text-gray-200 mb-8 leading-relaxed"
            >
              Esta seção está sendo preparada especialmente para você. 
              Entre em contato conosco através dos meios disponíveis na seção de contato 
              para obter informações mais detalhadas sobre o que deseja.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Contact Options */}
      <section className="py-24 bg-white">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Como Podemos Te Ajudar?
              </h2>
              <p className="text-lg text-gray-600">
                Nossa equipe está pronta para esclarecer suas dúvidas e fornecer 
                informações detalhadas sobre nossas soluções.
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="text-center p-8 bg-gradient-to-br from-kylix-background to-white rounded-2xl hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-kylix-primary to-kylix-secondary rounded-full flex items-center justify-center mx-auto mb-6">
                  <Mail className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Email</h3>
                <p className="text-gray-600 mb-6">
                  Envie suas dúvidas e receba uma resposta detalhada em até 24h
                </p>
                <a href="mailto:contato@smartdataerp.com.br" className="btn-primary w-full inline-flex items-center justify-center gap-2">
                  <Mail className="w-4 h-4" />
                  contato@smartdataerp.com.br
                </a>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="text-center p-8 bg-gradient-to-br from-kylix-background to-white rounded-2xl hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-kylix-primary to-kylix-secondary rounded-full flex items-center justify-center mx-auto mb-6">
                  <Phone className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Telefone</h3>
                <p className="text-gray-600 mb-6">
                  Fale diretamente com nossa equipe comercial
                </p>
                <a href="tel:+5515997464695" className="btn-primary w-full inline-flex items-center justify-center gap-2">
                  <Phone className="w-4 h-4" />
                  +55 (15) 99746-4695
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="py-24 bg-gray-50">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-3xl font-bold text-gray-900 mb-6"
            >
              Enquanto Isso, Que Tal Conhecer?
            </motion.h2>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="grid grid-cols-1 md:grid-cols-2 gap-8"
            >
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Nossas Soluções Especializadas
                </h3>
                <p className="text-gray-600 mb-6">
                  Conheça os ERPs inovadores já desenvolvidos para diferentes segmentos
                </p>
                <button className="btn-primary w-full">
                  Ver Soluções
                </button>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Nossa Tecnologia
                </h3>
                <p className="text-gray-600 mb-6">
                  Descubra o framework FormStudio e como ele evolui o desenvolvimento
                </p>
                <button className="btn-primary w-full">
                  Ver Tecnologia
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  )
}